const productionGaIds = {
  // APAC
  au: "G-Y4SFSK0VC5",
  hk: "G-354LSG0LFF",
  jp: "G-57BWEJEVG9",
  kr: "G-S77S27NNT2",
  nz: "G-MZSGZ01GNS",

  // EMEA
  de: "G-6RBZK36ZZ0",
  es: "G-BN3Q083XMW",
  eu: "G-BXZE3SJMWL",
  fr: "G-BW5YEPJEYK",
  gb: "G-8C26GX5TEN",

  // NAM
  ca: "G-SF6ZTR8GW2",
  mx: "G-7L1W1E5D3Y",
  us: "G-4ZRJ21056F",

  unknown: "G-40F3GB4ZFT",
} as const;

const stageGaIds = {
  // APAC
  au: "G-M5XQ1XRL65",
  hk: "G-Y0KKH6EE6Q",
  jp: "G-ZZT4CSQB10",
  kr: "G-N6YC62BVG0",
  nz: "G-3MY4L3SHVY",

  // EMEA
  de: "G-B3THKXSG6E",
  es: "G-RFTZJV91ZH",
  eu: "G-5GRCCJ8MVR",
  fr: "G-XRBGMJWV2G",
  gb: "G-PGX3FWF174",

  // NAM
  ca: "G-5CE3P598SG",
  mx: "G-G64DPTTN1Q",
  us: "G-JD9DDGHPTS",

  // Global fallback for stage
  unknown: "G-B97TMW4WPC",
} as const;

type GaIdMap = typeof productionGaIds;
type KnownRegion = keyof Omit<GaIdMap, "unknown">;

export function getGaIdForRegion(region: string, isStage: boolean): string {
  const map = isStage ? stageGaIds : productionGaIds;
  return map[region as KnownRegion] ?? map.unknown;
}

export { productionGaIds, stageGaIds };
